<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" type="primary" icon="plus" @click="tableAdd">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit" :disabled="!tableSelectedRows.length || tableSelectedRows.length !== 1">修改</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button>
				<a-button icon="sync" @click="apiColumnListQuery">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="栏目查询">
				<div class="qinang-search-row">
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">显示位置：</div>
						<a-select v-model="query.showPosition" style="width: 100%;" placeholder="请选择显示位置" allowClear>
							<a-select-option :value="1">导航</a-select-option>
							<a-select-option :value="2">其他</a-select-option>
						</a-select>
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">栏目名称：</div>
						<a-select v-model="query.parentId" style="width: 100%;" placeholder="请选择栏目名称" allowClear>
							<a-select-option :value="0">一级栏目</a-select-option>
							<a-select-option v-for="item in columnList" :key="item.columnId" :value="item.columnId">{{item.columnName}}</a-select-option>
						</a-select>
					</div>
					<div style="display: flex; justify-content: flex-end;">
						<a-button type="primary" icon="search" @click="apiColumnListQuery">查询</a-button>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<div style="display: flex;justify-content: space-between;align-items: center;">
				<a-breadcrumb separator=">" style="padding: 12.5px 16px;" >
					<a-breadcrumb-item>
						产品分类列表
					</a-breadcrumb-item>
				</a-breadcrumb>
			</div>
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="columnId" :loading="tableLoading" :pagination="false">
				<span slot="columnName" slot-scope="text, record">
					<a-button type="link" @click="edit(record)" >{{record.columnName}}</a-button>
				</span>
				<span slot="parentId" slot-scope="parentId">
					<span v-if="parentId.parentId == 0">一级栏目</span>
					<span v-else>{{ columnList.find(item => item.columnId == parentId.parentId).columnName }}</span>
				</span>
				<span slot="facilitatorId" slot-scope="facilitatorId">
					{{ facilitatorList.find(item => item.facilitatorId == facilitatorId.facilitatorId).facilitatorName }}
				</span>
				<span slot="showPosition" slot-scope="showPosition">
					{{showPosition.showPosition == 1 ? '导航' : '其他'}}
				</span>
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>


		<!-- 添加弹窗 -->
		<a-modal class="qa-modal-half" title="添加" width="600px" :visible="addVisible" :confirm-loading="addConfirmLoading" @ok="addHandleOk" @cancel="handleCancel" :maskClosable="false" :keyboard="false" >
            <a-form-model ref="addRuleForm" :model="addForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
				<a-form-model-item label="栏目名称" has-feedback prop="columnName">
					<a-input v-model="addForm.columnName" />
				</a-form-model-item>
				<a-form-model-item label="上级栏目" has-feedback prop="parentId">
					<a-select v-model="addForm.parentId" style="width: 100%;" placeholder="请选择上级栏目" allowClear>
						<a-select-option :value="0">一级栏目</a-select-option>
						<a-select-option v-for="item in columnList" :key="item.columnId" :value="item.columnId">{{item.columnName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="栏目图标" has-feedback prop="columnImg">
					<ImageUpload 
                        v-model="addForm.columnImg" 
                        :limit="1" 
                        :fileSize="1" 
                        :fileType="['png', 'jpg', 'jpeg']" 
                        :isShowTip="true"
                        @input="uploadPicUrlAdd"
                    />
				</a-form-model-item>
				<a-form-model-item label="服务商" has-feedback prop="providerId">
					<a-select v-model="addForm.facilitatorId" style="width: 100%;" placeholder="请选择服务商" allowClear>
						<a-select-option v-for="item in facilitatorList" :key="item.facilitatorId" :value="item.facilitatorId">{{item.facilitatorName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="排序" has-feedback prop="columnSort">
					<a-input v-model="addForm.columnSort" />
				</a-form-model-item>
				<a-form-model-item label="跳转地址" has-feedback prop="jumpUrl">
					<a-input v-model="addForm.jumpUrl" />
				</a-form-model-item>
				<a-form-model-item label="显示位置" has-feedback prop="showPosition">
					<a-radio-group name="columnPosition" v-model="addForm.showPosition">
						<a-radio :value="1">导航</a-radio>
						<a-radio :value="2">其他</a-radio>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="栏目状态" has-feedback prop="columnState">
					<a-radio-group name="columnState" v-model="addForm.columnState">
						<a-radio :value="2">禁用</a-radio>
						<a-radio :value="3">启用</a-radio>
					</a-radio-group>
				</a-form-model-item>
			</a-form-model>
		</a-modal>

		<!-- 修改弹窗 -->
		<a-modal class="qa-modal-half" title="修改" width="600px" :visible="editVisible" :confirm-loading="editConfirmLoading" @ok="editHandleOk" @cancel="handleCancel" :maskClosable="false" :keyboard="false" >
			<a-form-model ref="editRuleForm" :model="editForm" :label-col="{span: 5}" :wrapper-col="{span: 17}" :rules="addRules">
				<a-form-model-item label="栏目名称" has-feedback prop="columnName">
					<a-input v-model="editForm.columnName" placeholder="请输入栏目名称" />
				</a-form-model-item>
				<a-form-model-item label="上级栏目" has-feedback prop="parentId">
					<a-select v-model="editForm.parentId" style="width: 100%;" placeholder="请选择上级栏目" allowClear>
						<a-select-option :value="0">一级栏目</a-select-option>
						<a-select-option v-for="item in columnList" :key="item.columnId" :value="item.columnId">{{item.columnName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="栏目图标" has-feedback prop="columnImg">
                    <ImageUpload 
                        v-model="editForm.columnImg"
                        :limit="1" 
                        :fileSize="1" 
                        :fileType="['png', 'jpg', 'jpeg']" 
                        :isShowTip="true"
                        @input="uploadPicUrlEdit"
                    />
                </a-form-model-item>
				<a-form-model-item label="服务商" has-feedback prop="providerId">
					<a-select v-model="editForm.facilitatorId" style="width: 100%;" placeholder="请选择服务商" allowClear>
						<a-select-option v-for="item in facilitatorList" :key="item.facilitatorId" :value="item.facilitatorId">{{item.facilitatorName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="排序" has-feedback prop="columnSort">
					<a-input-number v-model="editForm.columnSort" placeholder="请输入排序" />
				</a-form-model-item>
				<a-form-model-item label="跳转地址" has-feedback prop="jumpUrl">
					<a-input v-model="editForm.jumpUrl" placeholder="请输入跳转地址" />
				</a-form-model-item>
				<a-form-model-item label="显示位置" has-feedback prop="showPosition">
					<a-radio-group name="columnPosition" v-model="editForm.showPosition">
						<a-radio v-for="item in typeList" :key="item.value" :value="item.value">{{item.label}}</a-radio>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="栏目状态" has-feedback prop="columnState">
					<a-radio-group name="columnState" v-model="editForm.columnState">
						<a-radio :value="2">禁用</a-radio>
						<a-radio :value="3">启用</a-radio>
					</a-radio-group>
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		
		
	</div>
</template>

<script>
	import moment from 'moment'
    import ImageUpload from '@/components/ImageUpload'
	export default {
        components:{
            ImageUpload
        },
		data() {
			return {
				moment,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				//类型列表
				typeList: [
                     {
                        label:'导航',
                        value:1
                    },
                    {
                        label:'其他',
                        value:2
                    },
                ],
				columnList: [],
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					facilitatorId: undefined,
					dutyName: '',
					parentId: undefined,
					showPosition: undefined,

				},
				mainNavigation:{},
				tableData: [],
				tableColumns: [
                    { title:'ID', dataIndex:'columnId', key:'columnId', align:'center'},
					{ title:'栏目名称', key:'columnName', align:'center',scopedSlots:{customRender:'columnName'}},
					{ title:'上级栏目', key:'parentId', align:'center',scopedSlots:{customRender:'parentId'}},
					{ title:'服务商', key:'facilitatorId', align:'center',scopedSlots:{customRender:'facilitatorId'}},
                    { title:'排序', dataIndex:'columnSort', key:'columnSort', align:'center'},
					{ title:'显示位置', key:'showPosition', align:'center', scopedSlots:{customRender:'showPosition'}},
				],
				tableLoading: false,
				tableSelectedRows: [],
				facilitatorList: [],
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				addForm: {
					facilitatorId: undefined,
					columnName: '',
					columnImg: '',
					columnSort: 0,
					columnState:3,
					showPosition: 1,
					jumpUrl: '',
				},
				addRules: {
					columnSort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
					columnName: [{ required: true, message: '栏目名称不能为空', trigger: 'blur' }],
					parentId: [{ required: true, message: '请选择上级栏目', trigger: 'change' }],
					facilitatorId: [{ required: true, message: '请选择服务商', trigger: 'change' }],
				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
					facilitatorId: undefined,
					columnName: '',
					columnImg: '',
					columnSort: 0,
					columnState:3,
					showPosition: 1,
					jumpUrl: '',
				},
				// 修改弹窗-end
			};
		},
		methods: {
            //获取服务商列表
			async apiFacilitatorList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFacilitatorList,{staffId:window.sessionStorage.getItem('staffId')});
				if (res.code == 200) {
					this.facilitatorList = res.data
				} else {
					this.$message.error(res.msg)
				}
			},
			//获取栏目列表
			async apiColumnList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiColumnList,{staffId:window.sessionStorage.getItem('staffId'),parentId:0});
				if (res.code == 200) {
					this.columnList = res.data
				} else {
					this.$message.error(res.msg)
				}
			},

			//--------------表格开始-搜索
			async apiColumnListQuery() {
				this.tableLoading = true
				this.query.staffId = window.sessionStorage.getItem('staffId')
				const {
					data: res
				} = await this.$http.post(this.navigation.apiColumnQueryList, this.query);
				if (res.code == 200) {
					this.tableLoading = false
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiColumnListQuery()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiColumnListQuery()
			},
			handleCancel() {
				this.addVisible = false
				this.editVisible = false

			},

			// 添加
			tableAdd() {
				this.addVisible = true
				this.addConfirmLoading = false
				this.addForm = {
					facilitatorId: undefined,
					columnName: '',
					columnImg: '',
					columnSort: 0,
					columnState:3,
					showPosition: 1,
					jumpUrl: '',
				}
				if(this.$refs.addRuleForm) {
					this.$refs.addRuleForm.resetFields();
				}
			},
			async apiColumnAdd() {
				this.addConfirmLoading = true
				this.addForm.staffId = window.sessionStorage.getItem('staffId')
				const {
					data: res
				} = await this.$http.post(this.navigation.apiColumnAdd, this.addForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					if(this.$refs.addRuleForm) {
						this.$refs.addRuleForm.resetFields();
					}
					this.addConfirmLoading = false
					this.addVisible = false
					// 等待弹窗关闭后再刷新列表
					this.apiColumnListQuery()
				} else {
					this.$message.error(res.msg)
					this.addConfirmLoading = false
				}
			},
			addHandleOk() {
				this.$refs.addRuleForm.validate(valid => {
					if (valid) {
						this.apiColumnAdd()
					} else {
						return false;
					}
				});
			},

			// 修改
			async edit(item){
				this.editConfirmLoading = false
				// 设置表单数据，确保 priceIdList 属性存在
				this.editForm = item
				// 先打开弹窗
				this.editVisible = true

			},
			async apiColumnEdit() {
				this.editConfirmLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiColumnEdit, this.editForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.editConfirmLoading = false
					this.editVisible = false
					// 等待弹窗关闭后再刷新列表
					this.apiColumnListQuery()
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			editHandleOk() {
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiColumnEdit()
					} else {
						return false;
					}
				});
			},
			editHandleCancel() {
				this.editVisible = false
			},
			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.length > 0) {
					const ids = this.tableSelectedRows.map(row=>row.columnId)
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: '当前选中' + ids.length + '条数据。',
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiColumnDel(ids)
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiColumnDel(ids) {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiColumnDel + '/'+ ids);
				if (res.code == 200) {
					this.$message.success(res.msg)
					await this.apiColumnListQuery()
				} else {
					this.$message.error(res.msg)
				}
			},
			tableEdit() {
				if(this.tableSelectedRows.length === 1) {
					const item = this.tableData.find(item => item.columnId == this.tableSelectedRows[0].columnId)
					console.log(item)
					this.edit(item)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			},
            //文件上传-开始
            uploadPicUrlAdd(val){
                this.addForm.columnImg = val
            },
            uploadPicUrlEdit(val){
                this.editForm.columnImg =val
            }

			//文件上传-结束
			
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					onChange: (selectedRowKeys, selectedRows) => {
						that.tableSelectedRows = selectedRows;
					},
				};
			},
		},
		created() {
            this.apiColumnList()
			this.apiColumnListQuery()
            this.apiFacilitatorList()
		}
	};
</script>

<style scoped>

</style>
